module.exports = __webpack_public_path__ + "static/audit-24f73cfda4e2a333dc4892d8e04670a7.gif";